import { CellItem } from '../../components/core/DataTable/dataTable.types';

export interface DashboardType {
  code: string;
  name: string;
}

export const dashboardTypes: DashboardType[] = [
  {
    code: 'MainDashboard',
    name: 'Main dashboard',
  },
  {
    code: 'ExternalUrl',
    name: 'External url',
  },
  {
    code: 'Grafana',
    name: 'Grafana',
  },
  {
    code: 'OpcDashboard',
    name: 'Opc Dashboard',
  },
];

export enum DashboardTypes {
  MAIN_DASHBOARD = 'MainDashboard',
  EXTERNAL_URL = 'ExternalUrl',
  GRAFANA = 'Grafana',
  OPC_DASHBOARD = 'OpcDashboard',
}

export interface Dashboard extends CellItem {
  id: number;
  assetId: number;
  type: string;
  name: string;
  url: string;
}

// *** Forms ***
export interface DashboardInputs {
  id: number;
  assetId: number;
  type: string;
  name: string;
  url: string;
  assetType?: AssetDashboardType;
}

// *** Requests ***
export interface DashboardUpdateRequest {
  id: number;
  assetId: number;
  name: string;
  url: string;
  assetType?: AssetDashboardType;
}

export interface DashboardCreateRequest {
  // id: number;
  assetId: number;
  type: string;
  name: string;
  url: string;
  assetType?: AssetDashboardType;
}

export enum AssetDashboardType {
  SCRAP = 'Scrap',
  CYCLE_TIME_ACTUAL = 'CycleTimeActual',
  CYCLE_TIME_AGGREGATED = 'CycleTimeAggregated',
  PROCESS_DATA = 'ProcessData',
  URL = 'URL',
}

export const assetDashboardTypes: DashboardType[] = [
  {
    code: 'Scrap',
    name: 'Scrap',
  },
  {
    code: 'CycleTimeActual',
    name: 'CycleTimeActual',
  },
  {
    code: 'CycleTimeAggregated',
    name: 'CycleTimeAggregated',
  },
  {
    code: 'ProcessData',
    name: 'ProcessData',
  },
  {
    code: 'URL',
    name: 'URL',
  },
];

export interface GrafanaDashboardCreateRequest {
  type: AssetDashboardType;
  assetId: number;
  name: string;
}
